import { Component, HostBinding, HostListener, OnInit, Renderer2 } from '@angular/core';
import { VersionService } from '../core/services/version.service';
import { AuthenticationService } from '../core/services/authentication.service';
import { UserService } from '../core/services/user.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SystemMessageModel } from '../../models/system-messages/system-message.model';
import { SystemMessageService } from '../core/services/system-message.service';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../core/components/bases/base-component';
import { SpinnerService } from '../core/services/spinner.service';
import { CanDeactivateService } from '../core/services/can-deactivate.service';
import { Title } from '@angular/platform-browser';
import { AppUserModel } from 'src/app/models/users/app-user.model';

@Component({
    selector: 'app-backend',
    templateUrl: './backend.component.html'
})
export class BackendComponent extends BaseComponent implements OnInit {
    @HostBinding('class') clazz = 'sidebar-hidden aside-menu-hidden';
    version: string;
    messages: SystemMessageModel[] = [];
    currentUser: AppUserModel;

    constructor(private versionService: VersionService,
                private authService: AuthenticationService,
                private userService: UserService,
                private router: Router,
                private systemMessageService: SystemMessageService,
                private spinnerService: SpinnerService,
                private renderer: Renderer2,
                private canDeactivateService: CanDeactivateService,
                private titleService: Title) {
        super();
    }

    ngOnInit() {
        this.getCurrentUser();
        this.titleService.setTitle('Backend – TROFACO');
        this.spinnerService.setupShowOnBodyUntil(this.renderer, this.onDestroy$);
        this.systemMessageService.messages$.pipe(takeUntil(this.onDestroy$))
            .subscribe(message => this.messages = [...this.messages, message]);
        this.versionService.version().subscribe(version => this.version = version);      

        const adminRoute = '/admin';
        if (this.router.url == adminRoute){
            this.router.navigateByUrl('admin/plantingSites');
        }
    }

    onMessageClosed(message: SystemMessageModel) {
        this.messages = this.messages.filter(m => m !== message);
    }

    async logout(event?: Event) {
        if (event) event.preventDefault();
        let success = await this.router.navigateByUrl('/admin/login');
        //could fail if there's pending changes and the user cancels navigation
        if (!success) return;
        this.authService.removeToken();
        this.userService.removeUser();
    }

    async getCurrentUser() {
        this.currentUser = await this.userService.getCurrentUserAsync();
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (!this.canDeactivateService.canDeactivate(false)) {
            $event.returnValue = true;
        }
    }
}
